import {NgxLoggerLevel} from 'ngx-logger';

export const environment = {
  production: false,

  apiHost: "https://staging.apicustomboxes.office.fedex.com",
  builderUrl: "https://storage.googleapis.com/fedex-mirakl-sandbox-cdn/builder",
  isBuilderProduction: false,

  config: {
    name: "fedex",
    title: "Custom Branded Boxes By FedEx",
    logo: "assets/fedex/images/fedex_logo.png",
    enableHealthCheckPolling: true,
    healthCheckUrl: "https://staging2.office.fedex.com/default/timeout/session/heartbeat",
    marketingSite: "https://staging.office.fedex.com/default/custom-branded-boxes",
    supportPhone: "1-555-555-5555",
    supportEmail: "support@example.com",
  },

  orderPrefix: "ST",

  features: {
    aiDesignChat: false,
    designOnline3d: true,
  },

  analytics: {
    enabled: true,
    ga4MeasurementId: "G-FV33E79GMX",
    debug: true,
    debugMode: true,
  },

  logger: {
    logLevel: NgxLoggerLevel.TRACE,
    serverLogLevel: NgxLoggerLevel.OFF,
    serverLoggingUrl: undefined,
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
